export default class OnlineMembershipTriage
{
    constructor(id){
        this.wrapper = document.querySelector(`#${id}`);
        this._step = 1;

        this.setup();
    }

    get questionsCount(){
        return this.wrapper.dataset.questioncount;
    }

    get step(){
        return this._step;
    }

    set step(value){

        if ( this._step < this.questionsCount || value < this._step )
        {
            // get old step element
            let $oldStep = $(`.OnlineMembershipTriageBreadcrumbs .OnlineMembershipTriageBreadcrumbsNumber[data-step='${this.step}']`);

            // hide old question
            $(`.jsTriageQuestion[data-step='${this.step}']`).hide();

            // mark old step as done
            $oldStep.removeClass('active').addClass('past');

            // increment steps
            this._step = value;

            // show new question
            $(`.jsTriageQuestion[data-step='${this.step}']`).show();

            // get new step element
            let $newStep = $(`.jsTriageQuestion:visible .OnlineMembershipTriageBreadcrumbs .OnlineMembershipTriageBreadcrumbsNumber[data-step='${this.step}']`);

            // mark new step as active
            $newStep.addClass('active');

            // scroll to active step     
            $('.jsTriageQuestion:visible .OnlineMembershipTriageBreadcrumbs').scrollLeft(($newStep.offset().left + $newStep.width() / 2) - ($('.jsTriageQuestion:visible .OnlineMembershipTriageBreadcrumbs').width() / 2));
        
            // toggle back button visibility
            if ( this._step > 1 ){
                $('.jsTriageGoBack').removeClass('d-none');
            }
            else
            {
                $('.jsTriageGoBack').addClass('d-none');
            }
        }
        else
        {
            // submit form
            this.submitForm();
        }
    }

    setup(){
        // hide triage and first question after init
        $('.jsTriageQuestion').hide();
        $(`.jsTriageQuestion[data-step='${this.step}']`).show();
        $('#OnlineMembershipTriage').show();

        // set first question as active
        $(`.OnlineMembershipTriageBreadcrumbs .OnlineMembershipTriageBreadcrumbsNumber[data-step='${this.step}']`).addClass('active');
    }

    submitForm(){
        this.wrapper.querySelector('#OnlineMembershipTriageForm').submit();
    }
}